export const truncate = (
  str: string,
  maxLength: number,
  ending: string = "..."
): string => {
  if (str.length > maxLength) {
    return str.substr(0, str.lastIndexOf(" ", maxLength)) + ending;
  }
  return str;
};
